import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import FaqData from '../Datas/Faq.json'
import { checkprotectedroutes, setActivity } from '../../Global/Index';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@mui/material';
import './Faq.css';

const Faq = () => {
  const themename = useSelector((state) => state.theme)
  const theme = useTheme();
  const [expandedSection, setExpandedSection] = useState(null);
  const [expandedQuestion, setExpandedQuestion] = useState(null);

  useEffect(() => {
    const checkfun = async () => {
      const resp = await checkprotectedroutes();
      setActivity('FAQ Page')
      if (resp.response.status === "419") {
        window.location.href = '/Session-Expired'
      } else if (resp.response.status === "500") {
        toast.error('Something went wrong. Please try again later!')
      } else if (resp.response.status === "503") {
        toast.warn(resp.response.message);
      } else if (resp.response.status == '401') {
        window.location.href = '/'
      }
    }
    checkfun()
  }, [])

  const toggleSection = (id) => {
    setExpandedSection(expandedSection === id ? null : id);
    setExpandedQuestion(null);
  };

  const toggleQuestion = (id) => {
    setExpandedQuestion(expandedQuestion === id ? null : id);
  };

  const data = FaqData[0];

  return (
    <>
      <ToastContainer />

      <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
        <h2>Frequently Asked Questions</h2>
        <div className="page-content page-container" id="page-content">
          <div className='mainsubcontainer' >
            <h4 className="faq-subtitle">Find answers to common questions about our services</h4>
            <div className={`faq-content ${themename}`}>
              {data.section.map((sec, sectionIndex) => (
                <div key={sec.id} className="faq-section" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                  <button
                    className={`section-header-faq ${expandedSection === sec.id ? 'active' : ''}`}
                    onClick={() => toggleSection(sec.id)}
                    aria-expanded={expandedSection === sec.id}
                  >
                    <div className="section-title">
                      <span className="section-number">{sectionIndex + 1}</span>
                      <span className="section-text">{sec.section_title}</span>
                    </div>
                    <div className="section-icon">
                      <i className={`bi ${expandedSection === sec.id ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                    </div>
                  </button>

                  <div className={`section-content ${expandedSection === sec.id ? 'expanded' : 'collapsed'}`}  style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                    {sec.question_answer.map((qa, index) => (
                      <div key={qa.id} className="question-item">
                        <button
                          className={`question-header ${expandedQuestion === qa.id ? 'active' : ''}`}
                          onClick={() => toggleQuestion(qa.id)}
                          aria-expanded={expandedQuestion === qa.id}
                        >
                          <div className="question-content">
                            <span className="question-number">Q{index + 1}</span>
                            <span className="question-text">{qa.question}</span>
                          </div>
                          <div className="question-icon">
                            <i className={`bi ${expandedQuestion === qa.id ? 'bi-dash' : 'bi-plus'}`}></i>
                          </div>
                        </button>

                        <div className={`answer-content ${expandedQuestion === qa.id ? 'expanded' : 'collapsed'}`}>
                          <div className="answer-wrapper">
                            <span className="answer-label">Answer:</span>
                            <div
                              className="answer-text"
                              dangerouslySetInnerHTML={{ __html: qa.answer }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Faq